import { render, staticRenderFns } from "./QuestionCard.vue?vue&type=template&id=07cc5c7e&scoped=true"
import script from "./QuestionCard.vue?vue&type=script&lang=ts"
export * from "./QuestionCard.vue?vue&type=script&lang=ts"
import style0 from "./QuestionCard.vue?vue&type=style&index=0&id=07cc5c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc5c7e",
  null
  
)

export default component.exports